import { createFileRoute } from '@tanstack/react-router';
import { PageStub } from '@/components/shared/PageStub';

export const Route = createFileRoute('/operations/systems')({
  component: () => <PageStub title="Systems Hub" description="Business systems and processes" />,
});
